import jwt_decode from "jwt-decode";
import {LocalParams} from "../components/LocalParams";
import {userLogout} from "../features/User/UsersSlice";
import {store} from "./store";

export const tokenExpiredCheckMiddleware = ({dispatch, getState}: any) =>{
  return (next: any) => (action: any) => {
    if(action.type && action.type.toLowerCase().includes("logout"))
    {
      return next(action);
    }
    else
    {
      const token = LocalParams.getItem("token");

      if(token)
      {
        try
        {
          const decodedToken: {exp: number} = jwt_decode(token);
          const nowTimestamp = Math.floor(new Date().getTime() / 1000);

          if(nowTimestamp >= decodedToken.exp) //Token expired, we logout
          {
            store.dispatch(userLogout(true));
          }
        }
        catch(err)
        {
        }
      }
    }

    return next(action);
  }
}
